<template>
  <v-card class="mt-3">
    <v-toolbar flat density="compact" color="transparent" height="100%">
      <v-row class="fill-height align-center">
        <v-col cols="6">
          <v-text-field
            v-model="search"
            clear-icon="mdi-close"
            append-inner-icon="mdi-magnify"
            label="Recherche"
            @keyup.enter="searchTrigger"
            @click:append-inner="searchTrigger"
            @click:clear="handleClearSearch"
            :error-messages="getErrorMessage"
            :error="searchError"
            :persistent-hint="showHint"
            :hint="hintText"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table-server
        :headers="headers"
        :items="materials"
        :hide-default-footer="hideActions"
        :items-per-page-options="[10, 25, 50, 100, 500]"
        :loading="loadingData"
        :no-data-text="noDataText"
        :items-length="totalItems"
        :items-per-page-text="rowsPerPageText"
        page-text="Lignes {0} - {1} de {2}"
        v-model:options="options"
      >
        <template v-slot:item="props">
          <tr @click="onItemSelect(props.item)">
            <td>
              <v-checkbox
                true-icon="mdi-checkbox-marked"
                false-icon="mdi-checkbox-blank-outline"
                :model-value="props.item.selected"
                color="primary"
                hide-details
              ></v-checkbox>
            </td>
            <td>{{ props.item.name }}</td>
          </tr>
        </template>
      </v-data-table-server>
      <v-divider></v-divider>
    </v-card-text>
    <v-snackbar v-model="showError" :timeout="6000" color="error" y="bottom">
      {{ nameError }}
      <v-btn variant="text" @click="showError = false">Fermer</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { GetAllPaging, GetSearch } from '@/_services/materials';
import { paginationMixin } from '@/classes/helper/paginationHelper';

export default {
  name: 'CatalogList',
  mixins: [paginationMixin],
  props: {
    allSelectedMaterials: {
      type: Array,
      required: true,
    },
    materialToDeselect: {
      type: Object,
    },
    activeTab: {
      type: Number,
    },
  },
  data() {
    return {
      noDataText: 'Chargement des matériaux.',
      noResultsText: 'Chargement des matériaux.',
      hintText: 'Appuyer sur la touche {enter} ou sur la loupe pour rechercher.',
      rowsPerPageText: 'Éléments par page',
      totalItems: 0,
      loadingData: false,
      alertData: false,
      alertColor: 'info',
      alertIcon: 'info',
      outline: true,
      search: '',
      oldSearch: '',
      showHint: false,
      searchError: false,
      error: false,
      nameError: 'Une erreur est survenue, veuillez vérifier vos informations et réessayer.',
      showError: false,
      headers: [
        {
          title: '',
          align: 'start',
          key: 'column-0',
          sortable: false,
          width: '50',
        },
        {
          title: 'Nom',
          align: 'start',
          key: 'name',
          sortable: false,
        },
      ],
      materials: [],
      take: 0,
      hideActions: false,
      currentTabNumber: 1,
    };
  },
  computed: {
    getErrorMessage() {
      if (this.searchError) {
        return this.noDataText;
      }
      return '';
    },
  },

  methods: {
    getDataFromApi() {
      this.showAlert('', 'info');
      this.loadingData = true;

      let take = this.take;
      const { page, rowsPerPage } = this.pagination;

      if (take === 0) {
        take = rowsPerPage;
      }
      GetAllPaging(take, (page - 1) * rowsPerPage)
        .then(rep => {
          this.materials = rep.materials.map(x => ({
            ...x,
            selected: false,
          }));
          this.totalItems = rep.itemCount;
          this.loadingData = false;
          this.showHint = true;
        })
        .catch(() => {
          this.error = true;
          this.materials = [];
          this.search = '';
          this.oldSearch = '';
          this.showAlert('', 'error');
        })
        .finally(() => {
          this.setSelectedMaterials();
        });
    },
    getSearch() {
      this.loadingData = true;
      let searchParam = this.search.trim();

      let take = this.take;
      const { page, rowsPerPage } = this.pagination;

      if (take === 0) {
        take = rowsPerPage;
      }

      GetSearch(searchParam, take, (page - 1) * rowsPerPage)
        .then(rep => {
          this.alertData = false;
          this.materials = rep.materials.map(x => ({
            ...x,
            selected: false,
          }));
          this.totalItems = rep.itemCount;
          this.loadingData = false;
          this.searchError = false;
          if (this.totalItems === 0) {
            this.error = true;
            this.showAlert('', 'warning');
            this.searchError = true;
          }
        })
        .catch(() => {
          if (page > 1) {
            GetSearch(searchParam, take, 0)
              .then(rep => {
                this.alertData = false;
                this.materials = rep.materials.map(x => ({
                  ...x,
                  selected: false,
                }));
                this.totalItems = rep.itemCount;
                this.loadingData = false;
                this.searchError = false;
                if (this.totalItems === 0) {
                  this.error = true;
                  this.showAlert('', 'warning');
                  this.searchError = true;
                }
              })
              .catch(() => {
                this.error = true;
                this.materials = [];
                this.search = '';
                this.oldSearch = '';
                this.showAlert('', 'error');
              });
          } else {
            this.error = true;
            this.materials = [];
            this.search = '';
            this.oldSearch = '';
            this.showAlert('', 'error');
          }
        })
        .finally(() => {
          this.setSelectedMaterials();
        });
    },
    searchTrigger() {
      if (this.oldSearch === this.search) {
        return;
      }
      this.oldSearch = this.search;
      this.searchError = false;
      if (this.search) {
        this.$nextTick(() => this.getSearch());
      } else {
        this.getDataFromApi();
      }
    },

    handleClearSearch() {
      this.oldSearch = null;
      this.searchError = false;
      this.$nextTick(() => this.getDataFromApi());
    },
    showAlert(msg, alertType) {
      this.alertData = false;
      switch (alertType) {
        case 'info':
          this.outline = true;
          this.alertColor = 'info';
          this.alertIcon = 'info';
          this.noDataText = 'Chargement des matériaux.';
          break;
        case 'warning':
          this.outline = false;
          this.alertColor = 'orange';
          this.alertIcon = 'warning';
          this.noDataText = `Votre recherche pour "${this.search.trim()}" n'a retourné aucun résultat.`;
          this.error = true;
          break;
        case 'error':
          this.outline = false;
          this.alertColor = 'error';
          this.alertIcon = 'error';
          this.noDataText = 'Une erreur est survenue. Veuillez réessayer.';
          this.error = true;
          break;
        default:
          break;
      }
      if (msg.trim() !== '') {
        this.noDataText = msg;
      }
      this.alertData = true;
    },
    onItemSelect(material) {
      material.selected = !material.selected;
      if (material.selected) {
        this.$emit('add-catalog-material', { material, type: 'catalog' });
      } else {
        this.$emit('remove-catalog-material', { material, type: 'catalog' });
      }
    },
    setSelectedMaterials() {
      this.materials = this.materials.map(x => ({
        ...x,
        selected: Boolean(this.isMaterialSelected(x)),
      }));
    },
    isMaterialSelected(material) {
      return this.allSelectedMaterials.find(x => x.materialPrototypeId === material.id || x.id === material.id);
    },
  },
  watch: {
    activeTab: {
      handler(tabNumber) {
        if (tabNumber === this.currentTabNumber) {
          this.getDataFromApi();
        }
      },
      immediate: true,
    },
    pagination: {
      handler(oldval, newval) {
        if (oldval.page !== newval.page || oldval.rowsPerPage !== newval.rowsPerPage) {
          if (this.search.trim().length < 3) {
            this.getDataFromApi();
          } else {
            this.getSearch();
          }
        }
      },
      deep: true,
    },
    materialToDeselect(newVal) {
      const material = this.materials.find(x => x.id === newVal.id);
      const index = this.materials.indexOf(material);
      if (index !== -1) {
        this.materials[index].selected = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
h4 .v-icon {
  margin-right: 5px;
}
</style>
